const config = {
  getApiUrl: () => 'https://app.tickmark-software.com/statisticstool/get-stats',
  getAppUrl: () => 'https://app.tickmark-software.com',
};

export default config;
